import { StyledAboutMeText } from "./styles";

const AboutMeText = () => {
  return (
    <StyledAboutMeText>
      <div className="top">
        <p>
          I find few things more gratifying than solving a challenging problem,
          especially those whose solutions require some ingenious and creative
          coding, or which require me to learn something new.
        </p>

        <p>Also, I love cats, coffee, videogames and music.</p>
      </div>
      <p>
        <b>Education:</b>
        <br />
        <br />
        <b>2016 - 2019:</b> Physics B.S. - Federal University of Paraná
        <br />
        <b>2020 - 2022:</b> Physics MSc - Federal University of Paraná
        <br />
        <b>2022 - 2023:</b> Kenzie Academy (full stack web development bootcamp)
      </p>
    </StyledAboutMeText>
  );
};

export default AboutMeText;
